var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridPpt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.885,
    height: 37.855,
    viewBox: "0 0 29.885 37.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75029",
    "data-name": "Group 75029",
    transform: "translate(-101 -669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62926",
    "data-name": "Path 62926",
    d: "M312.344,414.893v23.227a1.992,1.992,0,0,1-1.992,1.992h-25.9a1.993,1.993,0,0,1-1.992-1.992v-33.87a1.992,1.992,0,0,1,1.992-1.992H299.71a4.049,4.049,0,0,1,2.863,1.185l8.586,8.586A4.05,4.05,0,0,1,312.344,414.893Z",
    transform: "translate(-181.459 266.743)",
    fill: "#fff0d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63722",
    "data-name": "Path 63722",
    d: "M-6.43,6h2.96V1.461H-.981c3.22,0,5.093-1.921,5.093-4.717S2.272-8-.906-8H-6.43ZM-3.47-.911V-5.58h2c1.709,0,2.536.93,2.536,2.324A2.224,2.224,0,0,1-1.46-.911Z",
    transform: "translate(117.43 690)",
    fill: "#f27e33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridPpt);
export default __webpack_public_path__ + "static/media/grid_ppt.309180032367068aea70de7b89e58ded.svg";
export { ForwardRef as ReactComponent };